<template>
  <v-row>
    <v-col :cols="prependIcon ? 5 : 4">
      <CountryField
        :default="defaultCountryCode"
        v-model="countryCode"
        :errors="codeErrors"
        :prepend-icon="prependIcon ? usedIcon : null"
        :field-class="fieldClass"
      />
    </v-col>
    <v-col :cols="prependIcon ? 7 : 8">
      <v-text-field
        :append-icon="prependIcon ? null : usedIcon"
        v-model.trim="phoneNumber"
        :error-messages="localErrors"
        :label="$t('labels.phone')"
        :class="fieldClass"
        clearable
        @click:clear="onClear()"
        @blur="onBlur()"
      />
    </v-col>
  </v-row>
</template>

<script>
import { isEmpty } from 'lodash/lang'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import CountryField from './CountryField'
import { CustomFieldMixin } from '../mixins'

export default {
  name: 'PhoneField',
  mixins: [CustomFieldMixin],
  components: { CountryField },
  props: {
    icon: String,
    defaultCountryCode: [String, Number],
    prependIcon: { type: Boolean, default: false }
  },
  data: () => ({
    phoneNumber: null,
    countryCode: null,
    codeErrors: [],
    numberErrors: []
  }),
  watch: {
    phoneNumber: function (v) {
      this.processInput()
    },
    countryCode: function (v) {
      if (v) {
        this.codeErrors = []
        this.processInput()
      }
    }
  },
  computed: {
    localErrors() {
      return isEmpty(this.errors) ? this.numberErrors : [...this.errors, ...this.numberErrors]
    },
    usedIcon() {
      return this.icon || this.$vuetify.icons.values.mobile
    }
  },
  methods: {
    processInput(v) {
      if (!this.phoneNumber) {
        if (!this.required) {
          this.setValue(null)
          this.numberErrors = []
          return
        }
        this.numberErrors = [...this.numberErrors, this.$t('required')]
      }
      if (!this.countryCode) {
        this.codeErrors = [...this.codeErrors, this.$t('required')]
        return
      } else {
        this.codeErrors = []
      }
      let phone = this.formatNumer(this.phoneNumber, this.countryCode)
      if (phone && phone.isValid()) {
        this.setValue(phone.number)
        this.numberErrors = []
      } else {
        this.setValue(this.phoneNumber)
        this.numberErrors = [...this.numberErrors, this.$t('labels.invalid')]
      }
    },
    formatNumer(phoneNumber, countryCode) {
      if (!phoneNumber) {
        if (this.required) {
          this.numberErrors = [...this.numberErrors, this.$t('labels.required')]
        }
        return
      }
      let phone = countryCode
        ? parsePhoneNumberFromString(phoneNumber, countryCode)
        : parsePhoneNumberFromString(phoneNumber)
      if (phone && phone.isValid()) {
        this.phoneNumber = phone.formatNational()
        this.countryCode = phone.country
      }
      return phone
    },
    onBlur() {
      this.processInput()
    },
    onClear() {
      this.countryCode = null
    }
  },
  created() {
    if (this.value) {
      this.formatNumer(this.value)
    }
  }
}
</script>
